import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
var utils = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hasValue = hasValue;
  exports.isAdornedStart = isAdornedStart;
  exports.isFilled = isFilled;
  function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
  }
  function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
  }
  function isAdornedStart(obj) {
    return obj.startAdornment;
  }
});
export {utils as u};
